import React, { useEffect, useState } from "react"

import * as TrinityAPI from "../../../../requests/TrinityAPI"

import { ReplenishmentErrorBlock } from "./ReplenishmentErrorBlock"
import { IReplenishmentDto } from "../../../../types/replenishment/IReplenishmentDto"

export const ContractorCheckTab: React.FC<{
  next: () => void
  replenishment: IReplenishmentDto
  setReplenishment: (r: IReplenishmentDto) => void
}> = ({ next, replenishment, setReplenishment }) => {
  const [payerCompanyName, setPayerCompanyName] = useState<string>("")

  useEffect(() => {
    if (replenishment.clientRequestId && replenishment.status !== "NEW") {
      TrinityAPI.getClientRequest(Number(replenishment.clientRequestId), response => {
        if (response.status === 200) {
          setPayerCompanyName(response.data.clientCompanyName)
        }
      })
    }
  }, [replenishment])

  if (replenishment.status === "NEW") {
    return (
      <>
        <div className="container">
          <div className="container-pop-up">
            <ul className="form-left">
              <li className="form-block-popup">
                <h4 className="heading-chapter">Загрузка документов</h4>
                <p className="message-course-yes">
                  Клиент заполняет первичные данные и загружает документы. Пожалуйста, дождитесь окончания процесса
                </p>
              </li>
            </ul>
          </div>
        </div>
      </>
    )
  } else {
    return (
      <>
        <div className="container">
          <div className="container-pop-up">
            <ul className="form-left">
              <li className="form-block-popup">
                <h4 className="heading-chapter">Получатель валютных средств</h4>
                <fieldset>
                  <legend>Полное название</legend>
                  <p className="text-form">{replenishment.contractorName}</p>
                </fieldset>
                <fieldset>
                  <legend>Страна</legend>
                  <p className="text-form">{replenishment.contractorCountry?.name}</p>
                </fieldset>
                <fieldset>
                  <legend>Адрес</legend>
                  <p className="text-form">{replenishment.contractorAddress}</p>
                </fieldset>
                <ReplenishmentErrorBlock
                  replenishment={replenishment}
                  setReplenishment={setReplenishment}
                  fieldName={"contractorComment"}
                />
              </li>
              <li className="form-block-popup">
                <h4 className="heading-chapter">Счет</h4>
                <fieldset>
                  <legend>Банк</legend>
                  <p className="text-form">{replenishment.contractorBankName}</p>
                </fieldset>
                <div className="flex-row-10" translate="no">
                  <fieldset>
                    <legend>IBAN</legend>
                    <p className="text-form">{replenishment.contractorAccountNumber}</p>
                  </fieldset>
                  <fieldset>
                    <legend>SWIFT</legend>
                    <p className="text-form">{replenishment.contractorSwift}</p>
                  </fieldset>
                </div>
                <ReplenishmentErrorBlock
                  replenishment={replenishment}
                  setReplenishment={setReplenishment}
                  fieldName={"contractorBankComment"}
                />
              </li>
            </ul>
            <div className="right-form">
              <div className="form-block-popup">
                <h4 className="heading-chapter">Название компании плательщика</h4>
                <fieldset>
                  <legend>Полное название</legend>
                  <p className="text-form">{payerCompanyName}</p>
                </fieldset>
              </div>

              <div className="form-block-popup">
                <h4 className="heading-chapter">Контакты</h4>
                <fieldset>
                  <legend>ФИО</legend>
                  <p className="text-form">{replenishment.contractorContactName}</p>
                </fieldset>
                {/*<fieldset>*/}
                {/*  <legend>Должность</legend>*/}
                {/*  <p className="text-form">{replenishment.contractorContactJobTitle}</p>*/}
                {/*</fieldset>*/}
                <div className="flex-row-10">
                  {/*<fieldset>*/}
                  {/*  <legend>email</legend>*/}
                  {/*  <p className="text-form">{replenishment.contractorContactEmail}</p>*/}
                  {/*</fieldset>*/}
                  <fieldset>
                    <legend>Телефон</legend>
                    <p className="text-form">{replenishment.contractorContactPhone}</p>
                  </fieldset>
                </div>
                <ReplenishmentErrorBlock
                  replenishment={replenishment}
                  setReplenishment={setReplenishment}
                  fieldName={"contractorContactComment"}
                />
              </div>
            </div>
            {replenishment.status !== "DOC" ? (
              <></>
            ) : (
              <div className="flex-row-10">
                <button className="btn" onClick={next}>
                  Далее
                </button>
              </div>
            )}
          </div>
        </div>
      </>
    )
  }
}
